<form [formGroup]="form">
  <!-- Point of contact detail -->
  <section>
    <div class="fields-container">
      <h2 class="text-xl font-bold mt-5">
        {{ "MEDIATION.FORM.CONTACT_TITLE" | translate }}
      </h2>
      <p>{{ "MEDIATION.FORM.POINT_OF_CONTACT" | translate }}</p>

      <div class="field-control">
        <app-text-field
          [control]="form.get('pocFullName')"
          [label]="'MEDIATION.FORM.FullName' | translate"
          [validationMessages]="{
            english: 'VALIDATION_MSG.EN_LETTERS' | translate,
          }"
        ></app-text-field>
      </div>

      <div class="field-control">
        <app-text-field
          [control]="form.get('pocEmail')"
          [label]="'MEDIATION.FORM.Email' | translate"
          [validationMessages]="{
            email: 'VALIDATION_MSG.VALID_EMAIL' | translate,
          }"
        ></app-text-field>
      </div>

      <div class="field-control">
        <app-mobile-number
          [control]="form.get('pocMobile')"
          [countryCodeControl]="form.get('pocMobileCC')"
          [label]="'MEDIATION.FORM.Mobile' | translate"
          [validationMessages]="{
            mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate,
            uaeMobile: 'VALIDATION_MSG.UAE_MOBILE_NUMBER' | translate,
          }"
        />
      </div>

      <div class="field-control">
        <app-mobile-number
          [control]="form.get('pocPhone')"
          [label]="'MEDIATION.FORM.Phone' | translate"
          [countryCodeControl]="form.get('pocPhoneCC')"
          [validationMessages]="{
            uaePhoneNumber: 'VALIDATION_MSG.VALID_UAE_PHONE_NUMBER' | translate,
            mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate,
          }"
        />
      </div>

      <div class="field-control">
        <app-option-field
          [control]="form.get('pocCountry')"
          [label]="'MEDIATION.FORM.COUNTRY' | translate"
          [options]="countryList"
          [country]="true"
          (onSelectionChange)="onPocCountryChange($event)"
        ></app-option-field>
      </div>

      <div class="field-control">
        <app-option-field
          [control]="form.get('pocCity')"
          [label]="'MEDIATION.FORM.CITY' | translate"
          [lovType]="lookupKey.CITY_CODES"
        ></app-option-field>
      </div>
    </div>
  </section>

  <!-- Defaulter/Respondents detail -->
  <section>
    <h1 class="section-heading">
      {{ "MEDIATION.FORM.COMPANY_TITLE" | translate }}
    </h1>
    <p class="px-3">{{ "MEDIATION.FORM.COMPANY_SUB" | translate }}</p>
    @if (!DCMember) {
      <app-add-company
        [(isOpen)]="addCompanyModal"
        (onBtnClick)="submitCompanyDeatil($event)"
        [company]="defaulterCompany"
        [showAction]="false"
        [disableForm]="isDisableCompForm"
      />
    }
    <div class="fields-container">
      <div class="field-control">
        @if (DCMember) {
          <app-searchable-list
            [label]="'MEDIATION.FORM.SEARCH' | translate"
            [placeholder]="
              'MEDIATION.FORM.SEARCH_COMPANY_PLACEHOLDER' | translate
            "
            [control]="form.get('company')!"
            (onAdd)="setCompanySelected($event)"
            [options]="members"
            [allowAddNew]="false"
            [notFoundText]="'COMPANY_NOT_FOUND' | translate"
            (addNewItem)="addNewCompany()"
            [showAction]="showActions"
            [loading]="loadingMember"
            (search)="handleSearch($event)"
            [showSelectedItemsList]="false"
            [showPageNation]="false"
            [showMemberFilter]="true"
          ></app-searchable-list>

          <!-- Compnay/Member detail -->
          @if (defaulterCompany) {
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
              <div
                class="relative border border-dc-navy px-6 py-6 text-dc-navy dc-card-stretch"
              >
                <!-- Member Details -->
                <div class="space-y-4 dc-card-stretch-body">
                  <h3 class="text-2xl font-semibold text-dc-navy min-h-10">
                    {{ defaulterCompany.nameEnglish }}<br />
                    {{ defaulterCompany.nameArabic }}
                  </h3>

                  <div class="mb-4 space-y-4">
                    @if (defaulterCompany.country) {
                      <div class="dc-card-field">
                        <span class="dc-card-field-label">
                          {{ "COMPANY.COUNTRY" | translate }}</span
                        >
                        <span class="dc-card-field-value">
                          {{ defaulterCompany.country }}</span
                        >
                      </div>
                    }
                    <div class="dc-card-field">
                      <span class="dc-card-field-label">
                        {{ "COMPANY.EMAIL" | translate }}</span
                      >
                      <span class="dc-card-field-value">
                        {{ defaulterCompany.email }}</span
                      >
                    </div>

                    <div class="dc-card-field">
                      <span class="dc-card-field-label">
                        {{ "COMPANY.PHONE" | translate }}</span
                      >
                      <span class="dc-card-field-value">
                        {{ defaulterCompany.phone }}</span
                      >
                    </div>

                    <div class="dc-card-field">
                      <span class="dc-card-field-label">
                        {{ "COMPANY.CITY" | translate }}</span
                      >
                      <span class="dc-card-field-value">
                        {{ defaulterCompany.city }}</span
                      >
                    </div>

                    <div class="dc-card-field">
                      <span class="dc-card-field-label">
                        {{ "COMPANY.ADDRESS" | translate }}</span
                      >
                      <span class="dc-card-field-value">
                        {{ defaulterCompany.address }}</span
                      >
                      @if (defaulterCompany.poBox) {
                        <span class="dc-card-field-value">
                          {{ defaulterCompany.poBox }}</span
                        >
                      }
                    </div>
                  </div>
                  @if (showActions) {
                    <div class="dc-card-stretch-actions">
                      <div class="flex items-center gap-4 text-sm mt-7">
                        <a
                          class="card-action-edit-remove"
                          (click)="editDetail(defaulterCompany)"
                          >{{ "EDIT_DETAILS" | translate }}
                        </a>
                        <a
                          class="card-action-edit-remove"
                          (click)="removeCompany()"
                          >{{ "REMOVE" | translate }}
                        </a>
                      </div>
                    </div>
                  }
                </div>
                <!-- Bottom navy corner -->
                <div
                  [ngClass]="
                    companyContactError &&
                    defaulterCompany.respondentMemberNumber
                      ? 'dc-card-corner-red'
                      : 'dc-card-corner-green'
                  "
                ></div>
              </div>
            </div>
          }
        }
        <!--required field error msg -->
        @if (companyContactError && defaulterCompany.respondentMemberNumber) {
          <app-validation-message
            [type]="'error'"
            [content]="{
              title: 'ALERT.ERROR' | translate,
              message:
                'ALERT.MEDIATION_FILL_MISSINGFIELDS'
                | translate: { readableFields: companyContactError },
            }"
            (onBtnClick)="editDetail(defaulterCompany)"
          />
          <!-- <p class="text-sm text-red-600 mt-2">{{ companyContactError }}</p> -->
        }
      </div>
    </div>
  </section>

  <!-- section for dispute details -->
  <section>
    <div class="fields-container">
      <h2 class="text-xl font-bold mt-5 mb-5">
        {{ "MEDIATION.FORM.DISPUTE_TITLE" | translate }}
      </h2>
      <div class="field-control">
        <app-option-field
          [control]="form.get('type')"
          [label]="'MEDIATION.FORM.DISPUTE_TYPE' | translate"
          [lovType]="lookupKey.DISPUTE_TYPE"
        ></app-option-field>
      </div>
      <div class="field-control">
        <app-text-field
          type="big-text"
          [control]="form.get('details')"
          [label]="'MEDIATION.FORM.DISPUTE_DETAILS' | translate"
          [otherInfo]="'MEDIATION.FORM.DISPUTE_PLACEHOLDER' | translate"
          [maxlength]="2000"
        >
        </app-text-field>
      </div>

      <div class="field-control">
        <app-text-field
          [type]="'amount'"
          [control]="form.get('amount')"
          [currencyControl]="form.get('currency')"
          [label]="'MEDIATION.FORM.DISPUTE_AMOUNT' | translate"
          [currencyList]="currencyList"
        >
        </app-text-field>
      </div>

      <div class="field-control">
        <app-checkbox
          [control]="form.get('dateMode')"
          [label]="'MEDIATION.FORM.DATE_OF_TRANSATION' | translate"
          [otherInfo]="'MEDIATION.FORM.DATE_OF_TRANSATION_DESC' | translate"
          [options]="[
            { label: 'MEDIATION.FORM.DATE_RANGE' | translate, value: true },
          ]"
          [disabled]="!showActions"
          (onSelectionChange)="onDateRangeChange($event)"
        ></app-checkbox>

        <div class="mediation-date-range">
          <div class="mediation-date-range__from">
            <app-date
              [control]="form.get('dateFrom')"
              [allowedDate]="'past'"
              (onDateChange)="validateDateRange()"
            />
          </div>
          @if (form.get("dateMode")?.value) {
            <span class="mediation-date-range__separator">{{
              "MEDIATION.FORM.DATE_RANGE_TO" | translate
            }}</span>
            <div class="mediation-date-range__to">
              <app-date
                [control]="form.get('dateTo')"
                [allowedDate]="'past'"
                [validationMessages]="{
                  dateOrder: 'VALIDATION_MSG.DATE_TO_AFTER_FROM' | translate,
                  dateFuture: 'VALIDATION_MSG.DATE_TO_NOT_FUTURE' | translate,
                }"
                (onDateChange)="validateDateRange()"
              />
            </div>
          }
        </div>
        @if (dateErrorMsg) {
          <app-validation-message
            [type]="'error'"
            [showCloseIcon]="true"
            [content]="{
              title: 'ALERT.ERROR' | translate,
              message: dateErrorMsg | translate,
            }"
          >
          </app-validation-message>
        }
      </div>
      <div class="field-control">
        <app-text-field
          type="big-text"
          [control]="form.get('request')"
          [label]="'MEDIATION.FORM.REQUEST' | translate"
          [otherInfo]="'MEDIATION.FORM.REQUEST_DESC' | translate"
          [maxlength]="200"
        >
        </app-text-field>
      </div>
    </div>
  </section>

  <!-- section for payment method -->
  <!-- <section>
    <h1 class="section-heading">
      {{ "SECTION_PAYMENT_METHOD" | translate }}
    </h1>
    <div class="fields-container">
      <div class="field-control">
        <app-boolean
          [label]="'PAYMENT_METHOD' | translate"
          [control]="form.get('paymentMethod')!"
          [lovType]="lookupKey.PAYMENT_METHOD"
          [labelKey]="'Value'"
          [valueKey]="'Value'"
          (onSelectionChange)="onPaymentMethodChange($event)"
        />
      </div>
      @if ( noAdvancePaymentBalance) {
      <app-validation-message
        [content]="{
          title: 'ALERT.ERROR' | translate,
          message: 'ALERT.NO_ADVANCE_PAYMENT_BALANCE' | translate
        }"
        type="error"
      />
      }
    </div>
  </section> -->
</form>
